<template>
    <div>
        <div v-for="{filter, actions, totals} in profileActions[`${actionType}`]" class="tw-mt-4">
            <div class="tw-mb-10">
                <span class="tw-font-bold" v-text="filter.value"></span>
                <span class="tw-ml-6 tw-text-grey-dark">{{ totals[actionType] }} {{ actionLabel }}</span>
            </div>

            <div class="tw-flex tw-flex-wrap tw-justify-center lg:tw-justify-start">
                <div v-for="action in actions" :key="action.label" v-if="action.visible" class="stat tw-w-full tw-mb-4 tw-mx-2 tw-h-32 stat-left" :class="{'highlight': action.highlighted}">
                    <i class="fas fa-star pull-right"></i>
                    <span class="stat-name tw-mb-4" v-html="action.name"></span><br>
                    <p class="tw-flex tw-justify-between">
                        <span class="small-stat tw-leading-none" v-html="action.average"></span>
                        <span class="text-muted stat-unit tw-inline-flex tw-items-end" v-html="action.unit"></span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
    .stat {
        max-width: 14.4rem;
    }
</style>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: "GolfMetrics",

        props: {
            actionType: {required: true, type: String}
        },
        computed: {
            ...mapGetters({
                profileActions: 'player-profile/profileActions'
            }),
            actionLabel() {
                switch (this.actionType) {
                    case 'swing':
                        return 'Full Swings';
                    case 'short_game':
                        return 'Short Game';
                    case 'bunker':
                        return 'Bunker';
                    default:
                        return 'Putts';
                }
            }
        }
    }
</script>
